import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAjSB6eEijw42c3gyIx5frbjKLg5PtbLdY",
  authDomain: "accountingapp-d17b5.firebaseapp.com",
  projectId: "accountingapp-d17b5",
  storageBucket: "accountingapp-d17b5.firebasestorage.app",
  messagingSenderId: "999364838084",
  appId: "1:999364838084:web:e747874c26d223245b3f91",
  measurementId: "G-EGR9EKBG9D",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const sendManualReport = httpsCallable(functions, "sendManualReport");

// ✅ Safe conditional export of analytics
let analytics = null;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export { analytics };
